import { getDatePlusMinus } from '@einhaus/meteoric-helpers';
import { getDevelopmentCutoffDateTime } from '@einhaus/project314-shared';

// Keep the development default a day inside training, resolving it when a new form is created.
export const getFrontendSafeDevelopmentCutoffDateTime = (): string =>
    getDatePlusMinus('-', 1, 'day', 'ymdhms', 'start', getDevelopmentCutoffDateTime());
